export default "__VITE_ASSET__DEgnPLGV__"